import Cookies from 'js-cookie'

const TokenKey = 'token'
const Username = 'Username'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getUsername () {
  return Cookies.get(Username)
}

export function setUsername (idname) {
  return Cookies.set(Username, idname)
}

export function removeUsername () {
  return Cookies.remove(Username)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js